import { render } from "./ApprovedOrdersView.vue?vue&type=template&id=ab43f76c"
import script from "./ApprovedOrdersView.vue?vue&type=script&lang=js"
export * from "./ApprovedOrdersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__